/* eslint-disable @typescript-eslint/no-var-requires */
type GetModulesFn = () => any;

let getModules: GetModulesFn;

/////////////////
getModules = require('./se').default as GetModulesFn;
/////////

/////////////////
/////////////////////////////////////////////////////
/////////

/////////////////
/////////////////////////////////////////////////////
/////////

/////////////////
/////////////////////////////////////////////////////
/////////

////////////////////////
////////////////////////////////////////////////////////////
/////////

////////////////////////
////////////////////////////////////////////////////////////
/////////

////////////////////////
////////////////////////////////////////////////////////////
/////////

////////////////////////
////////////////////////////////////////////////////////////
/////////


///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////
/////////
/* eslint-enable @typescript-eslint/no-var-requires */


export { getModules };
